module.exports = __webpack_public_path__ + "assets/images/profiles/2020-main-4.jpg?v=ce734314";